import { Checkbox, List } from "antd";
import { useEffect, useRef, useState } from "react";
import { PiSealCheck } from "react-icons/pi";
import { useDispatch, useSelector } from "react-redux";
import assetsAssignImg from "../../../../assets/images/car.png";
import imagePlaceholder from "../../../../assets/images/imageplace.jpg";
import {
  InputField,
  Modal,
  SearchInput,
  SubmitButton,
  TextComponent,
} from "../../../../components";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import { AssetsMiddleware } from "../../../../Store/Middlewares/AssetsMiddleware";
import styles from "./groupAssets.module.css";

const EditGroupAssetModal = ({ isOpen, setIsOpen, details, resetAssets }) => {
  const dispatch = useDispatch();
  const [success, setSuccess] = useState(false);
  const [search, setSearch] = useState("");
  const [assetArray, setAssetArray] = useState(details?.assets || []);
  const [title, setTitle] = useState(details?.name || "");
  const SingleAssets = useSelector(
    (state) => state.AssetsReducer.getSingleAssets,
  );

  const ref = useRef();
  const onSearch = (e) => {
    setSearch(e.target.value);
    const value = e.target.value;
    clearTimeout(ref.current);
    ref.current = setTimeout(() => {
      dispatch(AssetsMiddleware.getSingleAssets(value)).then((data) => {});
    }, 1000);
  };

  const getData = (name) => {
    dispatch(AssetsMiddleware.getSingleAssets(name)).then((data) => {});
  };
  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (details) {
      setTitle(details?.name || "");
      setAssetArray(details?.assets || []);
    }
    if (!details) {
      setTitle("");
      setAssetArray([]);
    }
  }, [details, !details]);
  const onChange = (item) => {
    let dummyArr = [...assetArray];
    const findItem = dummyArr.find((e) => e?.id == item?.id);
    if (findItem) {
      const dltItem = assetArray.filter((e) => e?.id != findItem?.id);
      setAssetArray(dltItem);
    } else {
      dummyArr.push(item);
      setAssetArray(dummyArr);
    }
  };

  const onUpdateGroup = () => {
    let userData = {
      title,
      assetArray,
      id: details?.id,
    };
    // if(SingleAssets?.length == 0){
    //    dispatch(
    //     showAlert({
    //       type: "Error",
    //       message: "No single asset found",
    //     })
    //   );
    // }
    if (!title) {
      dispatch(
        showAlert({
          type: "Error",
          message: "Name fields is required",
        }),
      );
    } else {
      dispatch(AssetsMiddleware.updateAssetGroup(userData))
        .then(() => {
          resetAssets();
          setSuccess(true);
          setIsOpen(false);
          getData();
          // setAssetArray([]);
          // setTitle("");
        })
        .catch(() => {});
    }
  };
  const renderAssets = (item) => {
    const findItem = assetArray.find((e) => e?.id == item?.id);
    return (
      <div className={styles.moduleCont}>
        <div className={styles.moduleSubCont}>
          <img
            className={styles.moduleImg}
            src={item?.image ? item?.image : imagePlaceholder}
            alt="module image"
          />
          <TextComponent
            text={item?.device_id ? item?.device_id : "-"}
            className={styles.heading}
          />
        </div>

        <Checkbox checked={findItem} onChange={() => onChange(item)} />
      </div>
    );
  };

  const onPressBack = () => {
    setIsOpen(false);
  };

  // const renderTime = (item) => {
  //   return (
  //     <div className={styles.timeCont}>
  //       <TextComponent text={item?.type} className={styles.type} />
  //       <TextComponent text={item?.time} className={styles.time} />
  //       <TextComponent text={`"${item?.status}"`} className={styles.status} />
  //       <Switch
  //         // label="Enable Feature"
  //         size="small"
  //         disabled
  //         activeColor={"var(--green-color)"}
  //         inactiveColor={"var(--primary-color)"}
  //         initialChecked={item.status == "Drive" ? true : false}
  //         isChecked={item.status == "Drive" ? true : false}
  //         // onChange={handleSwitchChange} // Pass callback function
  //       />
  //       <IoCloseCircleSharp
  //         size={22}
  //         className={styles.crossIcon}
  //         style={{ alignSelf: "flex-end", marginLeft: "auto" }}
  //       />
  //     </div>
  //   );
  // };

  // const steps = ["Step 1", "Step 2"];

  return (
    <>
      {isOpen && (
        <Modal
          open={isOpen}
          onCancel={() => {
            // setStep(1);
            setIsOpen(false);
          }}
          width={"800px"}
          btnDiv={styles.access_modalBtn}
          btnStyle={{ width: "80%" }}
        >
          <div className={styles.mainCont}>
            {/* <Steps steps={steps} currentStep={step} /> */}
            <img src={assetsAssignImg} className={styles.carImg} />
            <TextComponent
              id={"title"}
              text={"Edit vehicle group"}
              className={styles.heading2}
            />

            <InputField
              label={"Group name"}
              className={styles.formDivideInput}
              placeholder={"Write here"}
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
            <SearchInput value={search} onChange={(e) => onSearch(e)} />
            <List
              dataSource={SingleAssets?.data}
              renderItem={renderAssets}
              style={{ width: "100%" }}
            />
            <SubmitButton
              title={"Save"}
              style={{ marginTop: "10px" }}
              onClick={onUpdateGroup}
            />
            <SubmitButton
              title={"Go Back"}
              style={{ marginTop: "10px" }}
              secondaryBtn
              onClick={onPressBack}
            />
            {/* <TextComponent text={"+4 more"} className={styles.more} /> */}
          </div>
        </Modal>
      )}
      <Modal
        open={success}
        onCancel={() => setSuccess(false)}
        icon={
          <PiSealCheck
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        // title={"Group Added Successfully"}
        title={"Changes Saved"}
        width={"400px"}
        buttonTitle={"Continue"}
        onBtnPress={() => {
          setSuccess(false);
        }}
        headingClass={styles.modalHeading}
      ></Modal>
    </>
  );
};

export default EditGroupAssetModal;
